const galleryImages = [
  { src: "/images/cowHides.jpeg", alt: "Cow Hides" },
  { src: "/images/roundMesquiteDiningTblSet.jpeg", alt: "Product Shelves" },
  { src: "/images/westernArt1.jpeg", alt: "Western Art" },
  { src: "/images/cons1.jpeg", alt: "Showroom" },
  { src: "/images/cons2.jpeg", alt: "Rustic Furniture Display" },
  { src: "/images/candles.jpeg", alt: "Customer Lounge Area" },
  { src: "/images/juniperBar.jpeg", alt: "Rugs" },
  { src: "/images/customOfficeChair.jpeg", alt: "Custom Office Chair" },
  { src: "/images/office1.jpeg", alt: "Office Furniture" },
  { src: "/images/office2.jpeg", alt: "Office Furniture" },
  { src: "/images/office3.jpeg", alt: "Office Furniture" },
  { src: "/images/office4.jpeg", alt: "Office Furniture" },
  { src: "/images/tileTable.jpeg", alt: "Custom Table" },
  { src: "/images/windmill.jpeg", alt: "Windmill Art" },
  { src: "/images/westernArt2.jpeg", alt: "Western Art" },
  { src: "/images/barTable.jpeg", alt: "Bar Table" },
  { src: "/images/juniperBar2.jpeg", alt: "Juniper Bar" },
  { src: "/images/cowHidePillows.jpeg", alt: "Cowhide Pillows" },
  { src: "/images/placemats.jpeg", alt: "Placemats" },
  { src: "/images/dogBed.jpeg", alt: "Dog Bed" },
  { src: "/images/coasterHolders.jpeg", alt: "Coaster Holders" },
  { src: "/images/keyChains.jpeg", alt: "Key Chains" },
  { src: "/images/pubTables1.jpeg", alt: "Pub Table" },
  { src: "/images/cowHide.jpeg", alt: "Cowhide" },
  { src: "/images/diningSet1.jpeg", alt: "Dining Set" },
  { src: "/images/diningSet2.jpeg", alt: "Dining Set" },
  { src: "/images/customSwivelChairs.jpeg", alt: "Custom Swivel Chairs" },
  { src: "/images/diningSet3.jpeg", alt: "Dining Set" },
  { src: "/images/customWingBackChairs.jpeg", alt: "Custom Wing Back Chairs" },
  { src: "/images/cowHideCons.jpeg", alt: "Cowhide Console" },
  { src: "/images/cowHideRunners.jpeg", alt: "Cowhide Runners" },
  { src: "/images/diningSet4.jpeg", alt: "Dining Set" },
  { src: "/images/diningSet5.jpeg", alt: "Dining Set" },
  { src: "/images/pubTable2.jpeg", alt: "Pub Table" },
  { src: "/images/pubTable3.jpeg", alt: "Pub Table" },
  { src: "/images/cons3.jpeg", alt: "Console" },
  { src: "/images/pubTable4.jpeg", alt: "Pub Table" },
  { src: "/images/mesquiteLamps.jpeg", alt: "Mesquite Lamps" },
  { src: "/images/cons4.jpeg", alt: "Console" },
  { src: "/images/cons5.jpeg", alt: "Console" },
  { src: "/images/cons6.jpeg", alt: "Console" },
  { src: "/images/cons7.jpeg", alt: "Console" },
  { src: "/images/coffeeTable1.jpeg", alt: "Coffee Table" },
  { src: "/images/pubTable5.jpeg", alt: "Pub Table" },
  { src: "/images/wingBackChair.jpeg", alt: "Wing Back Chair" },
  { src: "/images/cons8.jpeg", alt: "Console" },
  { src: "/images/diningSet6.jpeg", alt: "Dining Set" },
  { src: "/images/officeChair.jpg.png", alt: "Office Chair" },
  { src: "/images/nevadaTable.jpg.png", alt: "Nevada Table" },
  { src: "/images/desk1.jpg.png", alt: "Desk" },
  { src: "/images/westernArt3.jpg.png", alt: "Western Art" },
  { src: "/images/diningSet7.jpg.png", alt: "Dining Set" },
  { src: "/images/diningSet8.jpg.png", alt: "Dining Set" },
  { src: "/images/diningSet9.jpg.png", alt: "Dining Set" },
  { src: "/images/horns1.jpeg", alt: "Horns" },
  { src: "/images/horns2.jpeg", alt: "Horns" },
  { src: "/images/horns3.jpeg", alt: "Horns" },

];

export default galleryImages;